/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitFeedbackRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_feedback.pb'
import {SubmitFeedbackResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_feedback.pb'


export const submitFeedback = (request: SubmitFeedbackRequest, options?: CashRequestOptions) => post<SubmitFeedbackRequest, SubmitFeedbackResponse>("/cash-app/goose-cash/v3/submit-feedback", request, {...options, rejectOnError: true })